/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_NavInputs */

const en_mk_sol_ukm_nav = /** @type {(inputs: Mk_Sol_Ukm_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMEs, retail & F&B`)
};

const id_mk_sol_ukm_nav = /** @type {(inputs: Mk_Sol_Ukm_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UKM, ritel & F&B`)
};

/**
* | output |
* | --- |
* | "SMEs, retail & F&B" |
*
* @param {Mk_Sol_Ukm_NavInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_nav = /** @type {((inputs?: Mk_Sol_Ukm_NavInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_NavInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_nav(inputs)
	return en_mk_sol_ukm_nav(inputs)
});